import Link from "@/components/ui/RouterLink";
import { ArrowRight } from "lucide-react";
import { services } from "@/data/services";
import { categoryIcon } from "@/components/ui/icon-map";
import { emailPlan } from "@/data/products";

export function ServicesGrid() {
  return (
    <section className="mx-auto max-w-7xl px-5 py-10 lg:px-8">
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
        {services.map((s) => {
          const Icon = categoryIcon[s.id];
          const isEmail = s.id === "email";
          return (
            <div
              key={s.id}
              className="flex flex-col rounded-card border border-border bg-navy-card p-7 transition hover:border-cyan/40"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-border bg-navy-secondary text-cyan">
                <Icon className="h-5 w-5" strokeWidth={1.6} />
              </span>
              <h3 className="mt-5 font-display text-lg font-semibold text-text-primary">
                {s.headline}
              </h3>
              <p className="mt-2.5 text-sm leading-relaxed text-text-secondary">{s.description}</p>

              {isEmail && (
                <div className="mt-4 flex items-baseline gap-1.5 rounded-lg border border-border bg-navy-secondary px-3.5 py-2.5">
                  <span className="text-xs text-text-muted">{emailPlan.name}</span>
                  <span className="ml-auto font-display text-base font-semibold text-text-primary">
                    Starting at {emailPlan.price}
                  </span>
                </div>
              )}

              <ul className="mt-5 flex flex-wrap gap-2">
                {s.featureLabels.map((label) => (
                  <li
                    key={label}
                    className="rounded-full border border-border bg-navy-secondary px-2.5 py-1 text-[11px] text-text-secondary"
                  >
                    {label}
                  </li>
                ))}
              </ul>

              {isEmail && (
                <p className="mt-4 text-[11px] text-text-muted">
                  Final plan details and billing term are shown during checkout.
                </p>
              )}

              <Link
                href={s.href}
                className="focus-ring mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-cyan hover:underline"
              >
                {s.ctaLabel} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            </div>
          );
        })}
      </div>
    </section>
  );
}
